import { useCallback } from "react";
import { useFormAPI } from "@/widgets/classic-form/form";
import { usePageContextQuery } from "@/shared/page-context";
import { useEventFieldsWithExactnessDisabled } from "../shared/useEventFieldsWithExactnessDisabled";
import { applyEventExactness } from "./applyEventExactness";

export const useToggleEventExactness = () => {
    const { setFieldValue, getFieldValue } = useFormAPI();
    const config = useEventFieldsWithExactnessDisabled();
    const { data: pageContext } = usePageContextQuery();
    const defaultYearProximity = pageContext.runtimeConfig.defaultYearProximity;

    return useCallback(
        (newValue: boolean) => {
            const eventValues = getFieldValue("events");
            setFieldValue("events", applyEventExactness(eventValues, newValue, config, defaultYearProximity));
        },
        [getFieldValue, setFieldValue, config, defaultYearProximity],
    );
};
